export const SECTIONS = {
  recent: "recent",
  replies: "replies",
  all: "all",
  websiteforms: "websiteforms",
  phonecalls: "phonecalls",
  thirdparty: "thirdparty",
  walkin: "walkin",
  tasks: "tasks",
  appointments: "appointments",
  active: "active",
  deleted: "deleted",
  unmatched: "unmatched",
  bounced: "bounced",
  spam: "spam",
  advertisingsources: "advertisingsources",
  leaddistribution: "leaddistribution",
  autoresponders: "autoresponders",
  leadlifecycles: "leadlifecycles",
  contacts: "contacts"
} as const;

export type SectionKey = (typeof SECTIONS)[keyof typeof SECTIONS];

export const DEFAULT_SECTION: SectionKey = SECTIONS.all;

export const isSectionKey = (value: string | undefined): value is SectionKey =>
  !!value && Object.values(SECTIONS).includes(value as SectionKey);
